import {Injectable} from '@angular/core';
import {CoolLocalStorage, CoolSessionStorage} from '@angular-cool/storage';

@Injectable()
export class StorageService {
    constructor(private coolLocalStorage: CoolLocalStorage, private sessionStorage: CoolSessionStorage) {
    }

    saveItem(key: string, value: string) {
        this.coolLocalStorage.setItem(key, value);
    }

    getItem(key: string): string {
        return this.coolLocalStorage.getItem(key);
    }

    removeItem(key: string): void {
        return this.coolLocalStorage.removeItem(key);
    }

    public saveObject(key: Keys, value: Object): void {
        this.coolLocalStorage.setObject(key, value);
    }

    public getObject<T>(key: Keys): T {
        return this.coolLocalStorage.getObject<T>(key);
    }

    saveObjectToSession(key: Keys, value: Object) {
        return this.sessionStorage.setObject(key, value);
    }

    getObjectFromSession<T>(key: Keys): T {
        return this.sessionStorage.getObject<T>(key);
    }

    removeObjectFromSession(key: Keys): void {
        this.sessionStorage.removeItem(key);
    }

    clearSessionAndLocalStorage(): void {
        this.sessionStorage.clear();
        this.coolLocalStorage.clear();
    }

    clear(): void {
        this.coolLocalStorage.clear();
    }

    clearSessionStorage(): void {
        this.sessionStorage.clear();
    }
}

export enum Keys {
    BorrowerDashboardBreadcrumbs = 'borrowerDashboardBreadcrumbs',
    BorrowerDashboardBreadcrumbsPathDepth = 'borrowerDashboardBreadcrumbsPathDepth',
    LOAN_APPLICATION = 'loanApplication',
    IS_UPLOAD_DOCUMENT_COMPLETED = 'isUploadDocumentCompleted',

    PARTNER_LOGO = 'partner.logo',

    SELECTED_CREDIT_OPTION = 'selectedCreditOption',
    SELECTED_CREDIT_OPTION_ID = 'selectedCreditOptionId',
    EXTRA_OPTIONS_STATE = 'options.extraState',
    EXISTING_EMI = 'existingEmi',
    MONTHLY_SALARY = 'monthlySalary',
    MANUAL_INVEST_PORTFOLIO_CREATION = 'manualInvestPortfolioCreation',
    LOAN_ACCEPTED = 'loanAccepted',
    COMPONENT_REDIRECT = 'componentRedirect',
    PORTFOLIO_DETAILS = 'portfolioDetails',
    GRAY = 'gray',
    SUMMARY_FLAG = 'summaryFlag',
    PORTFOLIO = 'portfolio',
    EXPECTED_ROI = 'expectedRoi',
    PORTFOLIO_TYPE = 'portfolioType',
    INVESTMENT_TITLE = 'investmentTitle',
    REMAINING_AMOUNT = 'remainingAmount',
    BORROWED_INFO = 'borrowedInfo',
    PERSONAL_INFO = 'personalInfo',
    LOGIN_TOKEN = 'loginToken',
    SESSION_OUT = 'session_out',
    MOBILE = 'mobile',
    UPLOAD_DOCUMENTS = 'uploadDocuments',
    LIVELIHOOD_INFO = 'livelihoodInfo',
    EMPLOYMENT = 'employment',
    RESIDENCE_INFO = 'residenceInfo',
    DOC_TYPE = 'docType',
    EXTRA_DOC_TYPE = 'extradocType',
    EMAIL = 'email',
    MOBILE_NO = 'mobile_no',
    SUBMIT_LOAN = 'submitLoan',
    PORTFOLIO_ID = 'portfolio_id',
    INVEST_SUBMIT = 'investSubmit',
    PORTFOLIO_NAME = 'portfolio_name',
    INVESTMENT_TYPE = 'investment_type',

    PAN = 'pan',
    NAME = 'name',
    LENDER = 'lender',
    LOAN_ID = 'loan_id',
    BORROWER = 'borrower',
    LENDER_ID = 'lender_id',
    LOAN_AMOUNT = 'loanAmt',
    LOAN_REASON = 'loanPurpose',
    LOAN_PURPOSE = 'loanPurpose',
    LOAN_TENURE = 'loanTenure',
    WALLET_AMOUNT = 'walletAmount',
    PARTNER_IMAGE = 'partnerImage',
    REFERRER_CODE = 'referrerCode',
    IS_OTP_VERIFIED = 'otpVerified',
    REFERRER_USER_NAME = 'referrerUserName',
    INVESTMENT_AMOUNT = 'investment_amount',
    VERIFICATION_STATE = 'verificationState',
    FLAG_TO_BLOCK_INVEST = 'flagToBlockInvest',
    LOGIN_ID = 'loginId',
    GENERATED_USER_ID = 'generated_user_id',

    TOKEN = 'token',
    DOMAIN = 'domain',
    PARTNER = 'partner',
    PARTNER_ID = 'channel-partner-id',
    BANK_INFO = 'bankInfo',
    LENDER_BANK_INFO = 'lenderBankInfo',
    LENDER_NOMINEE = 'lenderNominee',
    PROFILE_ID = 'profile_id',
    PAN_VERIFIED = 'panVerified',
    LENDER_50K_LIMIT_CHECK = 'lender50kLimitDeclarationCheck',
    LENDER_LOAN_AGREEMENT_REVIEWED = 'lenderLoanAgreementReviewed',
    LENDER_10LAKH_LIMIT_CHECK = 'lender10LakhLimitDeclarationCheck',
    FINZY_FLEX_PRE_LAUNCH_AGGREMENT = 'finzyFlexPreLaunchAgreement',
    PHONE_VERIFICATION_REQUEST_TOKEN = 'phoneVerificationRequestToken',
    INVESTMENT_PREFERENCES = 'investmentPreferences',
    PARTNER_TRANSACTION_ID = 'partnerTransactionId',
    AMOUNT = 'amount',
    PAYMENT_PRODUCT = 'paymentProduct',
    FINX = 'finx',
    PARENT_WALLET_PATH = "paymentWalletPath",
    FIRST_LOGIN = "firstLogin",
    IFA_PAYMENT_LINK_UUID = 'ifaPaymentLinkUuid',
    HASHED_PROFILE_ID = 'hashedProfileId',
    TRANSACTION_STATUS = 'transactionStatus',
    IS_LENDER_CREATED_AFTER_RESTRICTED_DATE = 'isUserCreatedAfterRestrictedDate',
    GENERATED_LOAN_ID = 'generatedLoanId',
    PAYMENT_SUCCESS_REDIRECT_URL = 'paymentSuccessRedirectURL',
    PAYMENT_FAILED_REDIRECT_URL = 'paymentFailedRedirectURL',
    PAYMENT_REFERENCE_ID = 'paymentReferenceId',

    CIBIL_DATA = 'cibilData',
    SHOULD_EMAIL_FIELD_DISABLED = 'shouldLoanApplicationFlowEmailFieldDisabled',
    RETAILER_PARTNER_LINK_VALIDATED = 'retailerPartnerLinkValidated',
    COMING_FROM_RETAILER_PARTNER_PAYMENT_LINK = 'comingFromRetailerPartnerPaymentLink',
    IS_LOAN_APPLICATION_COMING_FROM_INDICATIVE_LOAN = 'isLoanApplicationComingFromIndicativeLoan',
    CREDIT_REPORT_ID = 'creditReportId',
    CREDIT_OPTION_ID = 'creditOptionId'
}
